















import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator';
import {
  namespace as wishStore,
  actionType as wishActionType,
} from '../../node_modules/sitis-nuxt/lib/store/modules/wishlist-store';

const WishStore = namespace(wishStore);

@Component
export default class WishlistButton extends Vue {
  @Prop({ type: String }) productId!: String;
  @Prop({ type: Boolean, default: false }) isMobile!: Boolean;

  loading = false;

  get isInWishlist() {
    const wishlist = this.$store.state?.wishlist?.items || [];

    return Boolean(wishlist.find((t: any) => String(t.id) === this.productId));
  }

  @WishStore.Action(wishActionType.GET_WISHLIST)
  readonly getWishList!: () => void;

  @WishStore.Action(wishActionType.ADD_TO_WISHLIST)
  readonly addToWishList!: (productId: number) => Promise<boolean>;

  @WishStore.Action(wishActionType.REMOVE_ITEM_FROM_WISHLIST)
  readonly removeFromWishList!: (productId: number) => Promise<boolean>;

  onClick(): void {
    if (this.isInWishlist) {
      this.removeFromWishList(Number(this.productId));
    } else {
      this.addToWishList(Number(this.productId));
    }
  }
}
